import { render, staticRenderFns } from "./purchaseScoreSettings.vue?vue&type=template&id=cfb56866&"
import script from "./purchaseScoreSettings.vue?vue&type=script&lang=js&"
export * from "./purchaseScoreSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports